import React from "react";

export const ItineraryIcon: React.FC<{
    color?: string;
    width?: string;
    height?: string;
}> = ({ color = "black", width = "40px", height = "20px" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 121.113 114.846"
        style={{ width, height }}
        fill={color}
    >
        <g id="itineraires" transform="translate(0 -13.244)">
            <g
                id="Groupe_34405"
                data-name="Groupe 34405"
                transform="translate(0 35.673)"
            >
                <path
                    id="Tracé_19961"
                    d="M31.4,108.06A31.434,31.434,0,0,0,0,139.459c0,8.256,3.859,20.309,9.83,30.7C16.633,182.008,24.494,188.8,31.4,188.8s14.767-6.793,21.569-18.637c5.971-10.4,9.83-22.449,9.83-30.7A31.434,31.434,0,0,0,31.4,108.06Zm0,76.255c-9.744,0-26.914-25.931-26.914-44.856a26.914,26.914,0,1,1,53.827,0C58.313,158.384,41.144,184.315,31.4,184.315Z"
                    transform="translate(0 -108.06)"
                />
            </g>
            <g
                id="Groupe_34407"
                data-name="Groupe 34407"
                transform="translate(15.7 51.373)"
            >
                <path
                    id="Tracé_19962"
                    d="M82.071,174.431a15.7,15.7,0,1,0,15.7,15.7A15.718,15.718,0,0,0,82.071,174.431Zm0,26.913a11.214,11.214,0,1,1,11.214-11.214A11.227,11.227,0,0,1,82.071,201.344Z"
                    transform="translate(-66.371 -174.431)"
                />
            </g>
            <g
                id="Groupe_34409"
                data-name="Groupe 34409"
                transform="translate(76.255 13.245)"
            >
                <path
                    id="Tracé_19963"
                    d="M344.8,13.245A22.454,22.454,0,0,0,322.37,35.673c0,11.292,13.63,33.642,22.428,33.642s22.428-22.35,22.428-33.642A22.454,22.454,0,0,0,344.8,13.245Zm0,51.584c-4.709,0-17.942-18.406-17.942-29.156a17.942,17.942,0,1,1,35.885,0C362.741,46.424,349.507,64.829,344.8,64.829Z"
                    transform="translate(-322.37 -13.245)"
                />
            </g>
            <g
                id="Groupe_34411"
                data-name="Groupe 34411"
                transform="translate(87.469 24.459)"
            >
                <path
                    id="Tracé_19964"
                    d="M380.992,60.653a11.214,11.214,0,1,0,11.214,11.214A11.227,11.227,0,0,0,380.992,60.653Zm0,17.942a6.728,6.728,0,1,1,6.728-6.728A6.736,6.736,0,0,1,380.992,78.6Z"
                    transform="translate(-369.778 -60.653)"
                />
            </g>
            <g
                id="Groupe_34413"
                data-name="Groupe 34413"
                transform="translate(42.614 71.557)"
            >
                <path
                    id="Tracé_19965"
                    d="M219.715,284.951c-2.7-2.25-3.947-4.624-3.809-7.255.307-5.868,7.574-11.972,10.347-13.828a2.243,2.243,0,0,0-2.49-3.731c-.484.322-11.838,8-12.335,17.313-.219,4.087,1.6,7.771,5.414,10.947,8.316,6.931,12.929,13.946,11.749,17.873-1.007,3.348-6.3,4.615-10.559,5.089a76.484,76.484,0,0,1-34.757-4.319,2.242,2.242,0,0,0-1.763,4.123,80.473,80.473,0,0,0,37.015,4.653c8.154-.906,12.984-3.683,14.359-8.255C235.318,299.466,225.676,289.921,219.715,284.951Z"
                    transform="translate(-180.151 -259.759)"
                />
            </g>
        </g>
    </svg>
);
